import { useLocation } from "@reach/router";
const initialize = async () => ({
  data: { scrollMemoPaths: {} }
});
const getHooks = (useFrameHooks) => {
  const useMemoizedPos = () => {
    const { useFrameContext } = useFrameHooks();
    const context = useFrameContext();
    return (path) => {
      var _a, _b;
      return (_b = (_a = context == null ? void 0 : context.scrollMemoPaths) == null ? void 0 : _a[path]) != null ? _b : 0;
    };
  };
  const useMemoize = () => {
    const { useFrameContext } = useFrameHooks();
    const { scrollMemoPaths } = useFrameContext();
    const location = useLocation();
    return () => {
      scrollMemoPaths[location.pathname] = window.scrollY;
    };
  };
  return { useMemoizedPos, useMemoize };
};
const scrollMemoModule = { initialize, getHooks };
export {
  scrollMemoModule
};
